module.exports = __webpack_public_path__ + "media/icons/filter-search-65f87e94.png";